import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringRuleAction } from '../priceFilteringRule.action';
import { PriceFilteringRuleTranslator } from '../priceFilteringRule.translator';

type IDependencies = IClientApiDependencySegment;

export const updatePriceFilteringRuleEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringRuleAction.update.started),
  mergeMap((params) => {
    const rules = params.map(PriceFilteringRuleTranslator.toApi);
    return dependencies.api.updatePriceFilteringRules({ rules }).pipe(
      mergeMap(() => {
        return [
          PriceFilteringRuleAction.update.done({ params, result: [] }),
        ];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringRuleAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
